import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, NEVER } from 'rxjs';
import { AppConfigService } from '../../app-config.service';

@Injectable()
export class ConseillerHttpInterceptor implements HttpInterceptor {
  private readonly EXCLUSIONS = [
    {
      method: 'POST',
      url: '/capacitescalculer'
    }
  ];

  constructor(private readonly _appConfig: AppConfigService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isConseiller && !(req.method === 'GET' || this.isAllowedMethod(req.method, req.url))) {
      return NEVER;
    }

    return next.handle(req);
  }

  private get isConseiller() {
    return this._appConfig.isConfigLoaded && this._appConfig.configData.conseiller;
  }

  isAllowedMethod(method, url) {
    return this.EXCLUSIONS.some(allowed => allowed.method === method && url.includes(allowed.url));
  }
}
